import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router";
import "./index.css";
import "@/i18n";
import App from "./App.tsx";
import ErrorBoundary from "@/pages/ErrorBoundary.tsx";
import * as Sentry from "@sentry/react";
import config from "@/config.ts";
import { version } from "../package.json";

Sentry.init({
  dsn: config.sentryDsn,
  release: version,
});
Sentry.captureMessage("Web app opened");

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <ErrorBoundary>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </ErrorBoundary>
  </StrictMode>,
);
